import {
  Component, Input,
} from '@angular/core';
import {
  addDetectionComment,
  addDetectionCommentFailure,
  addDetectionCommentSuccess,
  addDetectionEmergencySuccess,
  loadDetectionComments,
  loadDetectionCommentsSuccess
} from '../../../features/detection/detection.actions';
import { ofType } from '@ngrx/effects';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HistoryChannelComponents } from './history-channel.components';
import {
  newCommentReceived
} from '../../../features/websocket/websocket.actions';
import { Deserialize } from 'cerialize';
import { Comment } from '../../../models/comment';
import { first } from 'rxjs';
import { User } from '../../../models/user';
import { selectCurrentSite } from '../../../features/site/site.selectors';
import { Site } from '../../../models/site';
import { CommentType } from '../../../enums/comment';


@Component({
    selector: 'detection-history-channel',
    templateUrl: './history-channel.component.html',
    styleUrls: ['./history-channel.component.scss'],
    standalone: false
})
export class DetectionHistoryChannelComponents extends HistoryChannelComponents {

  @Input({required: true}) itemPool: string | undefined;

  override initHandleComments(): void {
    this.actions.pipe(ofType(addDetectionEmergencySuccess), takeUntilDestroyed())
      .subscribe(result => {
        this.loadComments();
      });
    this.actions.pipe(ofType(loadDetectionCommentsSuccess), takeUntilDestroyed())
      .subscribe(result => {
        this.comments = Object.assign([], result.comments);
        this.scrollToBottom();
        this.isLoading = false;
      });
    this.actions.pipe(ofType(addDetectionCommentSuccess), takeUntilDestroyed())
      .subscribe(result => {
        this.comments.push(result.comment);
        this.scrollToBottom();
        this.clearEditor();
      });
    this.actions.pipe(ofType(addDetectionCommentFailure), takeUntilDestroyed())
      .subscribe(result => {
        this.toastr.error(this.translocoService.translate("add_comment_failure"));
        this.clearEditor();
      });
    this.actions.pipe(ofType(newCommentReceived), takeUntilDestroyed())
      .subscribe(result => {
        if (result.comment) {
          const comment = Deserialize(result.comment, Comment);
          this.user$
            .pipe(first())
            .subscribe((user: User | undefined) => {
              if (user?.name !== comment.author || comment.commentType === CommentType.SYSTEM) {
                if (comment.targetId === this.itemPool) {
                  this.comments.push(comment);
                  this.scrollToBottom();
                }
              }
            });
        }
      });
  }

  override loadComments() {
    this.store.select(selectCurrentSite)
      .pipe(first())
      .subscribe((site: Site | null | undefined) => {
        if (site && this.itemId) {
          this.isLoading = true;
          this.store.dispatch(loadDetectionComments({
            organizationId: site.organization,
            siteId: site.id,
            detectionId: this.itemId
          }));
        }
      });
  }

  override onClickAddComment(fileNames: string[]): void {
    this.store.select(selectCurrentSite)
      .pipe(first())
      .subscribe((site: Site | null | undefined) => {
        if (site && this.itemId && this.textareaRef) {
          const payload: any = {'text': this.textareaRef.nativeElement.value};
          if (fileNames.length > 0) {
            payload.metadata = {
              site: site.id,
              attachments: fileNames
            };
          }

          this.store.dispatch(addDetectionComment({
            organizationId: site.organization,
            siteId: site.id,
            detectionId: this.itemId,
            payload
          }));
        }
      });
  }
}
